import { render, staticRenderFns } from "./DropFileBasic.vue?vue&type=template&id=0c28f926&scoped=true"
import script from "./DropFileBasic.vue?vue&type=script&lang=js"
export * from "./DropFileBasic.vue?vue&type=script&lang=js"
import style0 from "./DropFileBasic.vue?vue&type=style&index=0&id=0c28f926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c28f926",
  null
  
)

export default component.exports